export const formatDateTime = (
  date: Date | string,
  showTime = true
): string => {
  const dateObj = date instanceof Date ? date : new Date(date);
  const month = dateObj.toLocaleString("en-US", { month: "short" });
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const time = dateObj.toLocaleString("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "2-digit"
  });
  return `${showTime ? time : ""} ${day} ${month} ${year}`;
};

const startOfDay = (date: Date): number =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/** Compact age of a timestamp: "now" / "45min" / "10h" for today, "1d" / "7d" otherwise. */
export const formatRelativeTime = (date: Date | string): string => {
  const dateObj = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(dateObj.getTime())) {
    return "";
  }
  const now = new Date();
  const days = Math.round((startOfDay(now) - startOfDay(dateObj)) / 86400000);
  if (days > 0) {
    return `${days}d`;
  }
  const minutes = Math.floor((now.getTime() - dateObj.getTime()) / 60000);
  if (minutes < 1) {
    return "now";
  }
  if (minutes < 60) {
    return `${minutes}min`;
  }
  return `${Math.floor(minutes / 60)}h`;
};

/** "Synced 9:15 AM" from an ISO timestamp; undefined for an empty/invalid value.
 * Shared by the project (OverviewTab) and organisation dashboards' hero chips. */
export const formatSyncedTime = (syncedAt: string): string | undefined => {
  const date = new Date(syncedAt);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }
  return `Synced ${date.toLocaleTimeString("en-AU", {
    hour: "numeric",
    minute: "2-digit"
  })}`;
};
